import { render, staticRenderFns } from "./wordcontent.vue?vue&type=template&id=5bb0843a&scoped=true"
import script from "./wordcontent.vue?vue&type=script&lang=js"
export * from "./wordcontent.vue?vue&type=script&lang=js"
import style0 from "./wordcontent.vue?vue&type=style&index=0&id=5bb0843a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb0843a",
  null
  
)

export default component.exports